import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';
import { getTileUrl, getModelCoordinates } from '../config';

export class RelativeHumidityLayer extends BaseProduct {
  public readonly id: ProductId = 'relative_humidity';
  private lastModel: string = '';

  protected onActivate(): void {
    this.refresh();
  }

  protected onDeactivate(): void {
    this.layerManager.removeBufferedRasterLayer(this.id);
    this.layerManager.removeLayer(this.id);
    this.lastModel = '';
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh(targetTimeMs?: number) {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const opacity = getLayerOpacity(this.id, 1.0);
    const current = targetTimeMs !== undefined ? targetTimeMs : state.currentTimeStep;
    if (!current) return;

    const rawModel = state.selectedModels[this.id];
    const model = (rawModel && rawModel !== 'blend') ? rawModel : 'hrrr';

    if (this.lastModel && this.lastModel !== model) {
      this.layerManager.removeBufferedRasterLayer(this.id);
      this.layerManager.removeLayer(this.id);
    }
    this.lastModel = model;

    const ok = this.updateStandardInterpolatedRaster({
      layerId: this.id,
      product: this.id,
      model,
      targetTime: current,
      opacity,
      minzoom: 0,
      maxzoom: 5
    });
    if (!ok) {
      const d = typeof current === 'number' ? new Date(current) : current;
      const dateStr = d.toISOString().split('T')[0];
      const hourStr = String(d.getUTCHours()).padStart(2, '0');
      const tiles = [getTileUrl(manifest, this.id, model, dateStr, hourStr)];
      this.layerManager.updateBufferedRasterLayer(this.id, tiles, opacity, undefined, 0, 5, 'linear', getModelCoordinates(manifest, this.id, model));
    }
  }
}

export default RelativeHumidityLayer;
